import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PublicCollectionPage } from '@/features/bookmarks/views/public-collection-page';

function UsersCollectionRoute(): ReactNode {
  const { userId, slug } = Route.useParams();
  return <PublicCollectionPage userId={userId} slug={slug} />;
}

export const Route = createFileRoute('/users/$userId/collections/$slug')({
  component: UsersCollectionRoute,
});
